import { Link } from "react-router-dom";
import type { ReportTileMeta } from "../reports";

function categoryTestId(category: string): string {
  return category.toLowerCase().replace(/\s+/g, "-");
}

export default function ReportCatalog({ reports }: { reports: ReportTileMeta[] }) {
  // Group by category, preserving registry order (first appearance wins).
  const categories: string[] = [];
  for (const r of reports) {
    if (!categories.includes(r.category)) categories.push(r.category);
  }

  return (
    <div data-testid="report-catalog">
      {categories.map(category => (
        <section key={category} data-testid={`category-section-${categoryTestId(category)}`}>
          <h2
            style={{
              fontSize: "1.15rem",
              color: "#333",
              margin: "1.75rem 0 0",
              paddingBottom: "0.4rem",
              borderBottom: "1px solid #e5e5e5"
            }}
            data-testid={`category-header-${categoryTestId(category)}`}
          >
            {category}
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
              gap: "1.25rem",
              marginTop: "1.25rem"
            }}
          >
            {reports.filter(r => r.category === category).map(r => (
              <Link
                key={r.slug}
                to={`/reports/${r.slug}`}
                data-testid={`report-tile-${r.slug}`}
                style={{
                  display: "block",
                  padding: "1.25rem",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  background: "white",
                  textDecoration: "none",
                  color: "inherit",
                  transition: "border-color 0.15s, box-shadow 0.15s"
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor = "#0078d4";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,120,212,0.12)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = "#ddd";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div style={{ display: "flex", alignItems: "flex-start", gap: "0.75rem" }}>
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#0078d4"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                    style={{ flexShrink: 0 }}
                  >
                    <rect x="3" y="3" width="18" height="18" rx="2" />
                    <path d="M8 17V11M12 17V7M16 17V14" />
                  </svg>
                  <div>
                    <h3 style={{ margin: "0 0 0.25rem 0", fontSize: "1.05rem", fontWeight: 600, color: "#222" }}>
                      {r.name}
                    </h3>
                    <p style={{ margin: 0, fontSize: "0.85rem", color: "#666" }}>
                      {r.description}
                    </p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
